﻿import { FIQAssist } from "../app";
import { checklistitem } from "./checklist";
import { Component, Input, Output, Inject, Attribute, OutputArgs } from "@fiqas/angular-utils";
import { TranslationService } from "../services/TranslationService";
import {log} from "util";

@Component({
    module: FIQAssist,
    selector: 'checklistcombo',
    template: `<div class="checklistcombo ng-class:{isfocus:$ctrl.isfocus, readonly:$ctrl.readOnly, 'has-value':$ctrl.checked.length }" id="{{'checklistcombo_'+$id}}" click-outside="$ctrl.close()" ng-keydown="$ctrl.onKey($event)">
                <table tabindex="{{$ctrl.isEditable?0:-1}}" class="selector {{$ctrl.opened ? 'selectopen':'selectclose'}}" ng-click="$ctrl.open($event)" ng-focus="$ctrl.onFocus($event)" ng-blur="$ctrl.onBlur($event)">
                <tr>
                    <td rowspan="2" class="icon" tooltip-append-to-body="true" tooltip-class="customTooltipTB" tooltip-popup-delay="500" uib-tooltip="{{$ctrl.iconTooltip}}" ng-show="$ctrl.isEditable && $ctrl.handleLocation == 'left'">
                        <span class="{{$ctrl.opened ? 'icon-dropUP':'icon-dropdown'}}"><span class="path1"></span><span class="path2"></span></span>
                    </td>
                    <td class="selectText" placeholder="{{$ctrl.hint}}" title="{{$ctrl.selectText.length > 0 ? $ctrl.selectText : ''}}">
                        <span>{{$ctrl.selectText}}</span>
                        <span class="icon-clearField" ng-show="$ctrl.showClear" ng-click="$ctrl.ClearField($event)"></span>
                    </td>
                    <td rowspan="2" class="icon" ng-show="$ctrl.isEditable && $ctrl.handleLocation != 'left'">
                        <span class="{{$ctrl.opened ? 'icon-dropUP':'icon-dropdown'}}"><span class="path1"></span><span class="path2"></span></span>
                    </td>
                </tr>
                <tr>
                    <td class="border"></td>
                </tr>
                </table>
                <checklist read-only="$ctrl.readOnly" all-hovered="$ctrl._allhovered" class="checklistframe" ng-if="$ctrl.opened" items="$ctrl.items" all-text="$ctrl.allItemText" all-subset="$ctrl.allSubset"
                    show-all-option="{{$ctrl.showalloption}}" onitemselected="$ctrl.onitemselected(key, text)" onselectionchanged="$ctrl.onitemschanged(selected)"></checklist>
            </div>`
})
export class ChecklistCombo {
    constructor(
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$rootScope') private $rootScope: angular.IRootScopeService,
        @Inject('$element') private $element: angular.IRootElementService,
        @Inject() private translationService: TranslationService,
    ) {

    }

    @Input() public readOnly: boolean;
    private isInitialized: boolean = false;
    private oldSel: { key: any, text: string }[] = null;
    private hoveredItem: checklistitem;
    private _allhovered = false;
    private isfocus: boolean = false;

    public $onInit() {
        this.isInitialized = true;
        this.updateSelectionText();
    }

    @Input() public get items(): checklistitem[] {
        return this._items;
    }
    public set items(value: checklistitem[]) {
        this._items = value || [];
        this.updateSelection();
        this.updateSelectionText();
    }

    @Input() public get checked() {
        return this.items ? this.items.filter(i => i.checked).map(i => i.key) : [];
    }

    private _showClear;
    @Attribute() public get showClear() {
        return this._showClear;
    }
    public set showClear(val: boolean | string) {
        this._showClear = val === true || val === "true";
    }
    private ClearField($event: BaseJQueryEventObject) {
        this.items.forEach(i => i.checked = false);
        this.updateSelection();
        this.updateSelectionText();
        $event.preventDefault();
        $event.stopPropagation();
    }
    public set checked(val: { key: any }[]) {
        if (this.isInitialized) {
            this.items.forEach(i => i.checked = val && val.some(v => v.key == i.key));
            this.updateSelection();
            this.updateSelectionText();
        }
    }

    @Attribute() public handleLocation: "left" | "right";
    @Input() public allSubset: string[];
    @Input() public allItemText: string;

    @Input() public allSelectedText: string = "ALL_SELECTED";
    @Input() public subsetSelectedText: string = "SUBSET_SELECTED";
    @Input() public multipleSelectedText: string = "MULTIPLE_SELECTED";
    @Input() public noneSelectedText: string = "NONE_SELECTED";

    @Input() public showalloption: boolean;
    private _allowNoneSelected = true;
    @Attribute() public get allowNoneSelected() {
        return this._allowNoneSelected;
    }
    public set allowNoneSelected(value: string | boolean) {
        if (value === undefined)
            return;
        this._allowNoneSelected = value === true || value === "true";
    }
    @Output() public onliveselectionchanged: OutputArgs<{ selected: { key: any, text: string }[] }>;
    @Output() public onselectionchanged: OutputArgs<{ selected: { key: any, text: string }[] }>;

    public selectText: string = '';
    public opened: boolean = false;

    private _items: checklistitem[] = [];
    private subsetFilter = i => !this.allSubset || this.allSubset.length == 0 || this.allSubset.some(e => e == i.key);

    public get iconTooltip() {
        return this.opened ?
            this.translationService.Translate("COLLAPSE_TOOLTIP") :
            this.translationService.Translate("EXPAND_TOOLTIP");
    }

    public open(event) {
        //event.stopPropagation();
        if (this.isEditable) {
            this.opened = !this.opened;
            if (!this.opened) {
                this.updateSelection();
            } else {
                this.showSelection();
                if (this.hoveredItem) {
                    setTimeout(() => {
                        this.hoveredItem.hovered = true;
                        this.hoveredItem.child.hasfocus = true;
                    },0);
                }
            }
        }
    }

    public close() {
        if (this.opened) {
            this.opened = false;
            this.updateSelection();
        }
    }

    public onitemschanged(selected: { key: any, text: string }[]): void {
        if (this.isInitialized) {
            this.updateSelectionText();
            this.onliveselectionchanged({ selected: selected });
        }
    }
    @Output() public valueSumbit: OutputArgs<{ selected: { key: any, text: string }[] }>;
    public submitValue() {
        if (this.isInitialized && this.valueSumbit) {
            this.valueSumbit({ selected: this._items.filter(x => x.checked).map(item => { return { key: item.key, text: item.text }; }) });
        }
    }

    public onitemselected(key, text): void {
        if (this.isInitialized) {
            // set hovered-item
            if (this.hoveredItem != null) {
                this.hoveredItem.hovered = false;
                this.hoveredItem.child.hasfocus = false;
            }
            this.hoveredItem = this.items.filter(x => x.key === key)[0];
            if (this.hoveredItem) {
                this.hoveredItem.hovered = true;
                this.hoveredItem.child.hasfocus = true;
            }
        }
    }

    private updateSelectionText(): void {
        if (this._items.length > 1 && this._items.filter(o => !o.checked).length === 0)
            this.selectText = this.allSelectedText;
        else if (this.allSubset && this.allSubset.length > 0 && this._items.length > 0 && !this._items.filter(this.subsetFilter).some(o => !o.checked) && !this._items.filter(i => !this.subsetFilter(i)).some(o => o.checked))
            this.selectText = this.subsetSelectedText;
        else if (this._items.filter(o => o.checked).length > 1)
            this.selectText = this.multipleSelectedText;
        else if (this._items.filter(o => o.checked).length === 1)
            this.selectText = this._items.filter(o => o.checked)[0].text;
        else
            this.selectText = this.noneSelectedText;
    }

    private updateSelection(): void {
        if (this.isInitialized && !this.readOnly) {
            if (!this.allowNoneSelected && !this._items.some(o => o.checked)) {
                this._items.forEach(i => i.checked = true);
                this.updateSelectionText();
            }
            this.broadcastSelection();
        }
    }

    broadcastSelection() {
        var sel = this._items.filter(o => o.checked).map(i => { return { key: i.key, text: i.text }; });
        if (!this.areEqual(this.oldSel, sel)) {
            this.updateSelectionText();
            this.onselectionchanged({ selected: sel });
            this.oldSel = sel;
        }
    }

    private areEqual(old: { key: any, text: string }[], current: { key: any, text: string }[]): boolean {
        if (old == null)
            return false;
        if (old.length != current.length)
            return false;
        return old.every(x => current.filter(y => x.key == y.key && x.text == y.text).length == 1);
    }

    public get isEditable(): boolean {
        return !this.readOnly && this._items.length > 1;
    }

    private onFocus(event) {
        this.isfocus = true;
    }

    private onBlur(event) {
        this.isfocus = false;
    }

    public get allclicked(): boolean {
        return this.items.length > 0 && !this.items.filter(this.subsetFilter).some(x => !x.checked) && !this.items.filter(i => !this.subsetFilter(i)).some(x => x.checked);
    }

    private onKey($event: KeyboardEvent) {
        switch ($event.keyCode) {

            case 9:
                if (this.opened) {
                    this.$element[0].querySelector('.checklistcombo .selector').focus();
                    this.opened = false;
                }
                break;

            case 13:
                $event.preventDefault();
                // if (this.hoveredItem) {
                //     this.hoveredItem.checked = true;
                // } else {
                //     if (this._allhovered)
                //         this.items.forEach(x => x.checked = true);
                // }
                //this.broadcastSelection();
                this.opened = false;
                if (this.submitValue) this.submitValue();
                break;

            case 27:
                $event.preventDefault();
                this.opened = false;
                this.$element[0].querySelector('.checklistcombo .selector').focus();
                break;

            case 32:
                $event.preventDefault();
                if (!this.opened && this.isEditable) {
                    this.opened = true;
                    this.showSelection();
                } else {
                    if (this.hoveredItem) {
                        this.hoveredItem.checked = !this.hoveredItem.checked;
                    } else {
                        if (this.allclicked) {
                            this.items.forEach(x => x.checked = false);
                        } else {
                            this.items.forEach(x => x.checked = false);
                            this.items.filter(this.subsetFilter).forEach(x => x.checked = true);
                        }
                    }
                    this.broadcastSelection();
                    //this.opened = false;
                }
                break;

            case 38:
                if (this.opened) {
                    $event.preventDefault();
                    this.move(-1);
                }
                break;

            case 40:
                $event.preventDefault();
                if (!this.opened) {
                    this.open(null);
                    if (!this.checked.length) {
                        this._allhovered = true;
                        setTimeout(() => this.move(1),0);
                    }
                } else {
                    this.move(1);
                }
                break;

            case 37:
                if (this.opened) {
                    $event.preventDefault();
                    if (this.hoveredItem) {
                        this.hoveredItem.checked = false;
                    } else
                        this.items.forEach(x => x.checked = false);
                    this.updateSelectionText();
                }
                break;

            case 39:
                if (this.opened) {
                    $event.preventDefault();
                    if (this.hoveredItem) {
                        this.hoveredItem.checked = true;
                    } else {
                        //this.items.forEach(x => x.checked = true);
                        this.items.forEach(x => x.checked = false);
                        this.items.filter(this.subsetFilter).forEach(x => x.checked = true);
                    }
                }
                this.updateSelectionText();
                break;

            default:
                if (this.isEditable) {
                    var ucChar = $event.keyCode;
                    if (ucChar >= 65 && ucChar <= 90) {
                        $event.preventDefault();
                        this.opened = true;
                        var selection = this.items.filter(x => x.text && x.text.length > 0 && x.text.charCodeAt(0) == ucChar);
                        if (selection.length >= 0) {

                            this._allhovered = false;
                            if (this.hoveredItem != null) {
                                this.hoveredItem.hovered = false;
                                this.hoveredItem.child.hasfocus = false;
                            }
                            this.hoveredItem = selection[0];
                            this.hoveredItem.hovered = true;
                            this.hoveredItem.child.hasfocus = true;
                            this.scrollToViewAsync();
                        }
                    }
                }
        }
    }

    private move(direction: number) {
        if (!this.hoveredItem && !this._allhovered)
            this._allhovered = true;
        else if (this._items.length > 0) {
            var newindex = Math.max(-1, Math.min(this._items.length - 1, this._items.indexOf(this.hoveredItem) + direction));
            if (this.hoveredItem != null) {
                this.hoveredItem.hovered = false;
                this.hoveredItem.child.hasfocus = false;
            }
            if (newindex >= 0) {
                this._allhovered = false;
                this.hoveredItem = this._items[newindex];
                this.hoveredItem.hovered = true;
                this.hoveredItem.child.hasfocus = true;
            } else {
                this._allhovered = true;
                this.hoveredItem = null;
            }
        }
        this.scrollToViewAsync();
    }

    private showSelection() {
        this.items.forEach(x => x.hovered = false);
        this.hoveredItem = null;
        this._allhovered = false;
        if (this.items.every(x => x.checked)) {
            this._allhovered = true;
        } else {
            this.hoveredItem = this.items.filter(x => x.checked)[0];
            if (this.hoveredItem) {
                this.hoveredItem.hovered = true;
            }
        }
        this.scrollToViewAsync();
    }

    private async scrollToViewAsync() {
        await this.$timeout();
        if (this.opened) {
            var parent = this.$element[0].getElementsByClassName('checklist').item(0);
            var e = <any>(parent.getElementsByClassName('hovered').item(0));
            if (e) {
                parent.scrollTop = Math.max(0, e.offsetTop - ((parent.clientHeight - e.clientHeight) / 2));
            }
        }
    }
}
